import {
  ChevronDownSolid,
  ChevronUp
} from '@leroy-merlin-br/backyard-react-icons'

import * as S from './styled'

const Button = ({ onClick, isOpen }) => (
  <S.Button
    size="kilo"
    variant="ghost"
    onClick={onClick}
    iconRight={isOpen ? ChevronUp : ChevronDownSolid}
  >
    {isOpen ? 'Ver menos' : 'Ver mais'}
  </S.Button>
)

export default Button
